import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { 
  getAuth, 
  GoogleAuthProvider, 
  signInWithPopup,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
  onAuthStateChanged,
  sendEmailVerification as sendEmailVerificationFirebase
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCAaPiPTlb6fBXhY_yBZm8_P77gzy8oSz4",
  authDomain: "cheat-sheet-ai.firebaseapp.com",
  projectId: "cheat-sheet-ai",
  storageBucket: "cheat-sheet-ai.firebasestorage.app",
  messagingSenderId: "125644160081",
  appId: "1:125644160081:web:d795d80ca2c784176f0c70",
  measurementId: "G-BGGW6M760M"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// Helper function to send email verification
const sendEmailVerification = (user) => {
  return sendEmailVerificationFirebase(user);
};

export { 
  auth, 
  googleProvider,
  signInWithPopup,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
  onAuthStateChanged,
  sendEmailVerification
}; 